function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34 14H16C14.895 14 14 14.895 14 16V34C14 35.105 14.895 36 16 36H34C35.105 36 36 35.105 36 34V16C36 14.895 35.105 14 34 14ZM29.707 25.707L24.147 31.267C23.959 31.455 23.705 31.56 23.44 31.56C23.175 31.56 22.92 31.455 22.733 31.267L20.28 28.814C19.889 28.423 19.889 27.791 20.28 27.4C20.671 27.009 21.303 27.009 21.694 27.4L23.44 29.146L28.293 24.293C28.684 23.902 29.316 23.902 29.707 24.293C30.098 24.684 30.098 25.316 29.707 25.707ZM34 20H16V16H34V20Z"
});

function SvgIcEba31F804Bc04C639F3DB10Efc6Abbaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEba31F804Bc04C639F3DB10Efc6Abbaf);
export default ForwardRef;